import {MultiSelect} from 'primereact/multiselect';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseInputComponent from './BaseInputComponent';
import TemplateUtils from '../../utils/TemplateUtils';
import { ListBox } from 'primereact/listbox';
//import { Checkbox } from 'primereact/checkbox';
import { Checkbox } from '@mui/material';
import IconColorComponent from './IconColorComponent';

class InputMultiListBoxComponent extends BaseInputComponent {

    getValueByPath = (obj, path) => path.split('.').reduce((acc, key) => acc && acc[key], obj);

    renderView() {
        const {colClass, id, label, showLabel, value, optionLabel, iconValue, colorValue} = this.props;

        

        return (
            <div className={colClass}>
                <div className={'row'}>
                    <div className={'row mb-4 col-md-12 form-group'}>
                        {label !== undefined && showLabel ? (
                            <label id={`${id}-label-id`} className='p-label' htmlFor={id} style={{width: '100%'}}>
                                {label}
                            </label>
                        ) : null}
                            {value && value.length > 0 ? value.map(item => {
                                        return (
                                            <div 
                                                className='row' 
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'start',
                                                alignItems: 'center',
                                                width: 'fit-content',
                                                gap: '10px'
                                            }}
                                            >
                                                <div className='col-xl-1 col-lg-1 col-md-1 col-sm-1'>
                                                <IconColorComponent componentStyle={{ marginLeft: "0px", cursor: 'none' }} componentClassName={"col-1"} fontSize={"22px"}
                                                    icon={this.getValueByPath(item, iconValue)} 
                                                    color={this.getValueByPath(item, colorValue)} />
                                                </div>
                                                <div style={{
                                                    width: 'fit-content',
                                                }}>
                                                    <span style={{
                                                        fontSize: '12px',
                                                        width: 'fit-content'
                                                    }}>
                                                        {item[optionLabel]}
                                                    </span>
                                                </div>
                                            </div>
                                        )
                            })
                            : ''}
                    </div>
                </div>
            </div>
        );
    }

    renderEdit() {
        return this.renderNew();
    }

   
    renderNew() {
        const {
            colClass,
            dataKey,
            disableAllChecked,
            disabled,
            filter,
            filterBy,
            id,
            insideTable,
            label,
            name,
            selectedItemTemplate,
            maxSelectedLabels,
            onAfterStateChange,
            onChange,
            optionLabel,
            options,
            optionDisabledField,
            optionDisabledReversed,
            optionsDisabled,
            placeholder,
            selectedItemsLabel,
            showClear,
            showLabel,
            stateField,
            validator,
            validators,
            value,
            itemTemplate,
            display,
            chipColor
        } = this.props;
        //const required = validators !== undefined && validators.includes('array_required') && !validators.includes('not_required');
        
        const selectedItems = [];
        value.forEach(v => selectedItems.push(v));
        const availableItems = [];
        options.forEach(o => {
            if (!selectedItems.find(si => si.id === o.id)) {
                availableItems.push(o);
            }
        })


        const groupedOptions = [];
        groupedOptions.push({
            label: 'Wybrane',
            items: selectedItems
        });
        groupedOptions.push({
            label: 'Dostępne',
            items: availableItems,
        })        
        return (            
            <div className={colClass}>
                <div className={'row'}>
                    <div className={'col-md-12 form-group'}>
                        {label !== undefined && showLabel ? (
                            <label id={`${id}-label-id`} className='p-label' htmlFor={id} style={{width: '100%'}}>
                                {label}
                            </label>
                        ) : null}
                        <ListBox 
                            aria-describedby={`${id}-error`}
                            aria-label={label}
                            aria-labelledby={label === undefined && showLabel ? `${id}-label-id` : undefined}
                            id={id}
                            key={id}
                            name={name}
                            optionLabel={optionLabel}
                            style={{ width: '100%', background: '#f4f5fc'}} listStyle={{ maxHeight: '250px'}}
                            multiple filter={filter}
                            value={value}
                            options={groupedOptions} optionGroupLabel="label" optionGroupChildren="items"
                            onChange={(e) => (onChange ? onChange('MULTI_SELECT', undefined, e, onAfterStateChange, stateField) : null)}
                            itemTemplate={this.defaultImageItemTemplate.bind(this)}                            
                            dataKey={dataKey}                        
                        />                        
                        <div aria-live='assertive'>{validator ? validator.message(id, label, value, validators) : null}</div>
                    </div>
                </div>
            </div>
        );
    }

    defaultImageItemTemplate(item) {
        const {value, optionLabel, iconValue, colorValue} = this.props;
        const checked = value?.filter(v => v.id == item.id).length > 0;
        return (
            <div className='p-multiselect-token'>
                <Checkbox 
                    checked={checked}                    
                    color='black'
                />
                <IconColorComponent
                    componentStyle={{
                        marginRight: '10px'
                    }}
                    fontSize={"22px"}
                    icon={this.getValueByPath(item, iconValue)}
                    color={this.getValueByPath(item, colorValue)}
                />
                <span>
                    {item[optionLabel]}
                </span>
            </div>
        );
    }

    render() {
        const {rendered, viewMode} = this.props;
        if (rendered) {
            switch (viewMode) {
                case 'NEW':
                    return this.renderNew();
                case 'EDIT':
                    return this.renderEdit();
                case 'VIEW':
                default:
                    return this.renderView();
            }
        } else {
            return null;
        }
    }
}

InputMultiListBoxComponent.defaultProps = {
    colClass: 'col-xl-4 col-lg-6 col-md-6 col-sm-12',    
    filter: false,
    filterBy: 'label',    
    placeholder: 'Wybierz',
    rendered: true,
    showLabel: true,
    stateField: 'element',
    validateViewMode: false,
    itemTemplate: undefined,
    validators: 'not_required',
    viewMode: 'VIEW',
    colorValue: 'color.value',
    iconValue: 'icon.value'
};

InputMultiListBoxComponent.propTypes = {
    colClass: PropTypes.string,
    dataKey: PropTypes.string,
    disableAllChecked: PropTypes.bool,
    disabled: PropTypes.bool,
    filter: PropTypes.bool,
    filterBy: PropTypes.string,
    id: PropTypes.string.isRequired,
    insideTable: PropTypes.bool,
    label: PropTypes.string.isRequired,
    maxSelectedLabels: PropTypes.number,
    name: PropTypes.string.isRequired,
    onAfterStateChange: PropTypes.func,
    selectedItemTemplate: PropTypes.func,
    onChange: PropTypes.func,
    optionDisabledField: PropTypes.string,
    optionDisabledReversed: PropTypes.bool,
    optionLabel: PropTypes.string,
    options: PropTypes.array.isRequired,
    optionsDisabled: PropTypes.bool,
    placeholder: PropTypes.string,
    rendered: PropTypes.bool,
    selectedItemsLabel: PropTypes.string,
    showClear: PropTypes.bool,
    showLabel: PropTypes.bool,
    stateField: PropTypes.string,
    validateViewMode: PropTypes.bool,
    validator: PropTypes.object,
    validators: PropTypes.string,
    value: PropTypes.array,
    viewMode: PropTypes.string,
    display: PropTypes.string,
    chipColor: PropTypes.string,
    iconValue: PropTypes.string, 
    colorValue: PropTypes.string
};

export default withTranslation()(InputMultiListBoxComponent);
